import { render, staticRenderFns } from "./ModalCadastraAusentes.vue?vue&type=template&id=5be40f28"
import script from "./ModalCadastraAusentes.vue?vue&type=script&lang=js"
export * from "./ModalCadastraAusentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports